import {searchFormHelpers} from './search_form_helpers';
import {translations} from '../translations.js.erb'

var $mlsNumberField;
var $dataSourceField;
var noResultsMessage;

function init() {

  noResultsMessage = translations.g.no_results;

  $mlsNumberField = $("#search_fields_ListingId_value");
  $dataSourceField = $('#search_fields_MlsId_value');

  $('#content').fadeIn(200);
  hidePageLoadingMsg(200);

  $dataSourceField.flexSelect2();

  bindFormChanges();
  bindViewResultsClick();

  $('#list_container_form').submit(function(e) { 
    e.preventDefault();
    $('.view-results')[0].click();
  });

}

function bindFormChanges() {
  $mlsNumberField.keyup( $.debounce(500, function(e) {
    if(e.keyCode === 13) {
      $('.view-results')[0].click();
    } else if( $(this).val().length >= 4){
      searchFormHelpers.findCount();
    } else {
      searchFormHelpers.updateViewResultsHref('');
      $('.view-results').text(noResultsMessage).addClass('disabled');
    }
  }) );

  $dataSourceField.change(function() {
    searchFormHelpers.findCount();
  });

  window.addEventListener('searchForm:filterChanged', function(e) {
    searchFormHelpers.updateViewResultsHref(e.detail);
    $('.view-results').removeClass('disabled');
  });
}

function bindViewResultsClick() {
  if($mlsNumberField.val().length < 4) {
    $('.view-results').addClass('disabled');
  }

  $('.view-results').click(function(e) {
    if ($(this).hasClass('disabled')) {
      e.preventDefault();
    }      
  });

}

export var mlsNumberSearch = {
  init: init
};
